import React, { useState } from 'react';
import {
  Box,
  Flex,
  Button,
  Heading,
  Input,
  IconButton,
  InputGroup,
  InputRightElement,
  SimpleGrid,
  Text,
  useMediaQuery,
} from '@chakra-ui/react';
import { FaHome, FaWallet, FaShoppingBasket, FaExchangeAlt, FaUser, FaBell, FaPlusCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const productsData = [
  { id: 1, name: 'Product A', price: '$50' },
  { id: 2, name: 'Product B', price: '$75' },
  { id: 3, name: 'Product C', price: '$100' },
  // Add more products here
];

const requestsData = [
  { id: 1, product: 'Product A', restaurant: 'Restaurant X' },
  { id: 2, product: 'Product B', restaurant: 'Restaurant Y' },
  // Add more requests here
];

const UserMarket = () => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [products] = useState(productsData);
  const [requests] = useState(requestsData);
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  const filteredProducts = products.filter(product =>
    product.name.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  
  return (
    <Box p={4}>
      {!isMobile && (
        <Flex bg="blue.200" p={2} mt={-9} mb={4} align="center" justify="space-between">
        <Link to="/user-home">
        <Text
            size="md"
            fontWeight="semibold"
            color="white"
            _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
        >
            Home
        </Text>
        </Link>
          <Link to="/user-wallet">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Wallet
            </Text>
          </Link>
          <Link to="/user-market">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Market
            </Text>
          </Link>
          <Link to="/user-trades">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Trades
            </Text>
          </Link>
          <Link to="/user-account">
            <Text
              size="md"
              fontWeight="semibold"
              color="white"
              _hover={{ textDecoration: 'underline', borderBottom: '3px solid white' }}
            >
              Account
            </Text>
          </Link>          
            <Link to="/user-notifications">        
                <IconButton
                    icon={<FaBell />}
                    variant="ghost"
                    colorScheme="blue"
                    aria-label="Notifications"
                />        
            </Link>    
        </Flex>
      )}     

 
      <Text size="lg" fontWeight="bold">Marketplace</Text>

      {/* Search input */}
      <InputGroup mb={4} w={["100%", "100%", "60%"]} mx="auto">
        <Input
          placeholder="Search products..."
          value={searchKeyword}
          onChange={e => setSearchKeyword(e.target.value)}
        />
        <InputRightElement>
          {/* Add a search icon here */}
        </InputRightElement>
      </InputGroup>

        {/* Add Product Button */}
      <Button
        colorScheme="blue"
        bg={'blue.200'}
        leftIcon={<FaPlusCircle />}
        mb={4}
        onClick={() => {
          // Add logic to handle adding products
        }}
      >
        Add  a Product
      </Button>

      {/* Listed products */}
      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4}>
        {filteredProducts.map(product => (
          <Box
            key={product.id}
            bg="white"
            p={4}
            borderRadius="md"
            boxShadow="md"
            borderColor="blue.200"
            borderWidth="1px"
          >
            <Text color="blue.200" fontWeight="medium">
              {product.name}
            </Text>
            <Text color="gray.500" mt={1}>
              Price: {product.price}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {/* Requests */}
      <Heading mt={4} mb={2} fontSize="md">
        Requests from Restaurants
      </Heading>
      <SimpleGrid columns={1} spacing={4}>
        {requests.map(request => (
          <Box
            key={request.id}
            bg="white"
            p={4}
            borderRadius="md"
            boxShadow="md"
            borderColor="blue.200"
            borderWidth="1px"
          >
            <Text color="blue.200" fontWeight="medium">
              Request for: {request.product}
            </Text>
            <Text color="gray.500" mt={1}>
              From: {request.restaurant}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {isMobile && (
        <Flex bg="blue.200" p={2} mt={4} align="center" justify="space-between" position="fixed" bottom={0} width="95%">
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-home">
                <Flex alignItems="center" flexDirection="column">
                <FaHome />
                <Text color="white" fontSize="xs" mt={1}>
                    Home
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-wallet">
                <Flex alignItems="center" flexDirection="column">
                <FaWallet />
                <Text color="white" fontSize="xs" mt={1}>
                    Wallet
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-market">
                <Flex alignItems="center" flexDirection="column">
                <FaShoppingBasket />
                <Text color="white" fontSize="xs" mt={1}>
                    Market
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-trades">
                <Flex alignItems="center" flexDirection="column">
                <FaExchangeAlt />
                <Text color="white" fontSize="xs" mt={1}>
                    Trades
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-notifications">
                <Flex alignItems="center" flexDirection="column">
                <FaBell />
                <Text color="white" fontSize="xs" mt={1}>
                    Notifications
                </Text>
                </Flex>
            </Link>
            </Box>
            <Box textAlign="center" flex="1" p={2}>
            <Link to="/user-account">
                <Flex alignItems="center" flexDirection="column">
                <FaUser />
                <Text color="white" fontSize="xs" mt={1}>
                    Account
                </Text>
                </Flex>
            </Link>
            </Box>
        </Flex>
        )}

    </Box>
  );
};

export default UserMarket;
